'use client'
import React, {createContext, FC, memo, ReactNode, useCallback, useState} from 'react';
import {useContextStrict} from "@web-libs/core/context/context.functions";
import Lightbox from "@web-libs/features/lightbox/lightbox";

interface LightboxContextType {
    (url: string): void;
}

const LightboxContext = createContext<LightboxContextType | null>(null);
LightboxContext.displayName = 'LightboxContext';

export const useLightbox = (): LightboxContextType => {
    return useContextStrict(LightboxContext);
};

interface LightboxProviderProps {
    children: ReactNode;
}

export const LightboxProvider: FC<LightboxProviderProps> = ({ children }) => {
    const [isLightboxOpen, setLightboxOpen] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<string | null>(null);

    const openImage = useCallback((url: string) => {
        setImageUrl(url);
        setLightboxOpen(true);
    },[]);

    const closeImage = () => {
        setImageUrl(null);
        setLightboxOpen(false);
    };

    return (
        <ActualProvider value={openImage}>
            {children}
            {isLightboxOpen && imageUrl && <Lightbox imageUrl={imageUrl} onClose={closeImage} />}
        </ActualProvider>
    );
};

const ActualProvider: FC<{ value: LightboxContextType, children: ReactNode }> = ({ value, children }) => (
    <LightboxContext.Provider value={value}>
        {children}
    </LightboxContext.Provider>
);
